export default function wordcount(input=""){
    if(input.length===0){
        return 0;
    }
    let arr = input.trim().split(/\s+/)
    return arr.length;
}